import { useEffect } from 'react';
import type { CmsExternalServiceModalSubscription } from './cms.types';
import {
	cmsEvents,
	cmsExternalServiceModalSubscription,
	CmsSubscriptionTypes,
} from './cmsEvents';

interface CmsEventsProps {
	onCmsExternalServiceModal?: (
		action: CmsExternalServiceModalSubscription['type'],
		payload: CmsExternalServiceModalSubscription['payload']
	) => void;
}

export const useCmsEvents = ({
	onCmsExternalServiceModal,
}: CmsEventsProps = {}) => {
	useEffect(() => {
		const cmsExternalServiceModalSub =
			onCmsExternalServiceModal &&
			cmsEvents.subscribe(
				CmsSubscriptionTypes.externalServiceModal,
				onCmsExternalServiceModal
			);

		return () => {
			cmsExternalServiceModalSub?.unSubscribe();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps -- These dependencies are correct
	}, []);

	const cmsExternalServiceModal = (
		payload: CmsExternalServiceModalSubscription['payload']
	) => {
		cmsEvents.publish(cmsExternalServiceModalSubscription(payload));
	};

	return { cmsExternalServiceModal };
};
